export default "__VITE_ASSET__CusHo99q__"